/* eslint-disable react-refresh/only-export-components -- This file exports a
   route MANIFEST, not components. Its screen is defined inside a factory so it
   can close over the API client, which puts it beyond Fast Refresh's reach
   whatever this file exports. */

/**
 * What notifications contribute to the route tree.
 *
 * No permission requirement, and that is not an omission. These are the
 * signed-in person's own notifications — the same posture as `/me` — and the
 * server scopes every query to the recipient. A permission would imply
 * somebody could be granted the right to read another person's, which is
 * exactly what the endpoint refuses to allow.
 */

import type { ApiClient } from "@hardauto/core-api";
import type { FeatureRoutes } from "@hardauto/core-router";

import { NotificationsScreen } from "./screens/NotificationsScreen";
import "./i18n";

export const NOTIFICATION_PATHS = {
  list: "/notifications",
} as const;

export function notificationRoutes(client: ApiClient): FeatureRoutes {
  function Notifications() {
    return <NotificationsScreen client={client} />;
  }

  return {
    id: "notifications",
    routes: [
      {
        path: NOTIFICATION_PATHS.list,
        component: Notifications,
        layout: "app",
        requirement: { authenticated: true },
        nav: { labelKey: "notifications:nav.notifications", section: "account", order: 10 },
      },
    ],
  };
}
